const config = {
    api: {
        domain: 'https://api.salesbr.net',
        url: '/api/v3',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    sentry: {
        dsn: 'https://f71a7fdfa9024738934c1bb10aaa20af@o411701.ingest.sentry.io/5287309',
    },
    cdn: {
        endpoint: 'https://salescdn.net',
    },
};

export default config;
